<template>
  <div id='CustomerConsumptionChart'></div>
</template>

<script>
import G2 from '@antv/g2';
import chartMixin from '../chartMixin';

export default {
  name: 'CustomerConsumptionChart',
  mixins: [chartMixin],
  props: {
    consumeCount: {
      type: Object,
    },
  },
  data() {
    return {
      totalDom: null,
      countDom: null,
    };
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      this.chart = new G2.Chart({
        container: 'CustomerConsumptionChart',
        forceFit: true,
        height: this.height,
        padding: [50, 80, 50, 100],
      });
      this.chart.source(this.data);
      this.chart
        .axis('payableMoney')
        .coord()
        .transpose();

      // 图例
      this.chart.tooltip(false).legend(false);
      // 坐标系及着色
      this.chartGeom = this.chart
        .interval()
        .position('serviceName*payableMoney')
        .color('serviceName', ['#4e82fb', '#fb774e', '#ffc934', '#41bf52'])
        .label('payableMoney', {
          offset: 10,
          formatter: val => {
            return this.$formatPrice(Number(val));
          },
        });

      this.chart.render();
      this.chart.guide().text({
        top: true,
        position: ['100%', '100%'],
        content: '(元)',
        offsetX: 20,
        offsetY: 8,
      });
    },
    updateData() {
      this.totalDom = document.querySelector('.CustomerConsumption-total');
      this.countDom = document.querySelector('.CustomerConsumption-count');

      if (this.totalDom && this.countDom) {
        let money =
          this.consumeCount && this.consumeCount.payableMoney
            ? this.$formatPrice(this.consumeCount.payableMoney)
            : '0.00';
        let menCount =
          this.consumeCount && this.consumeCount.payMen
            ? this.consumeCount.payMen
            : '0';
        this.totalDom.innerHTML = money + '元';
        this.countDom.innerHTML = menCount + '笔';
      }
    },
  },
};
</script>
